export const searchUsersTour = {
  key: "searchUsers",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="search-users-root"]',
      content: t("Tour_SearchUsers_Root"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="search-users-form"]',
      content: t("Tour_SearchUsers_Form"),
      placement: "bottom",
    },
    {
      target: '[data-tour="search-users-nearme"]',
      content: t("Tour_SearchUsers_NearMe"),
      placement: "bottom",
    },
    {
      target: '[data-tour="search-users-results"]',
      content: t("Tour_SearchUsers_Results"),
      placement: "top",
    },
  ],
};
